import { apiURL, axiosInstance } from "constants/config";
import {
  loadDeliveryDetailsRequested,
  loadDeliveryDetailsSuccess,
  loadDeliveryDetailsFail,
  loadAssignDeliveryDetailRequested,
  loadAssignDeliveryDetailSuccess,
  loadAssignDeliveryDetailFail,
  loadDeliveryChargesListRequested,
  loadDeliveryChargesListSuccess,
  loadDeliveryChargesListFail,
  storeDeliveryDetailRequested,
  storeDeliveryDetailSuccess,
  storeDeliveryDetailFail,
  updateDeliveryDetailRequested,
  updateDeliveryDetailSuccess,
  updateDeliveryDetailFail,
  archiveDeliveryDetailRequested,
  archiveDeliveryDetailSuccess,
  archiveDeliveryDetailFail,
} from './deliverySlice';
import { put, call, takeEvery } from "redux-saga/effects";
import toast from "react-hot-toast";

export function* loadDeliveryDetailsEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/delivery-charges?SearchValue=${
        action?.payload?.filters?.query ?? ''
      }&PaginationOption.Page=${
        action.payload?.page
      }&PaginationOption.PageSize=${action.payload?.perPage}`
    );
    yield put(loadDeliveryDetailsSuccess(data));
  } catch (error: any) {
    yield put(loadDeliveryDetailsFail(error.meessage));
  }
}

export function* loadDeliveryChargesListEffect(): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/delivery-charges/list`
    );
    yield put(loadDeliveryChargesListSuccess(data));
  } catch (error: any) {
    yield put(loadDeliveryChargesListFail(error.meessage));
  }
}

export function* storeDeliveryDetailEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${apiURL}/delivery-charges`,
      action.payload
    );
    if (data?.succeeded) {
      yield put(storeDeliveryDetailSuccess(data));
      toast.success("Delivery charge added successfully");
    } else {
      toast.error('Delivery charge added  failed! ', data?.errors);
    }
  } catch (error: any) {
    yield put(storeDeliveryDetailFail(error.message));
  }
}

export function* updateDeliveryDetailEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.put,
      `${apiURL}/delivery-charges/${action.payload?.id}`,
      action?.payload
    );
    if (data?.succeeded) {
      yield put(updateDeliveryDetailSuccess(data));

      yield call(loadDeliveryDetailsEffect, {
        payload: { filters: {}, perPage: 10, page: 1 },
        type: "",
      });

      toast.success('Delivery Charge updated successfully');
    }
  } catch (error: any) {
    yield put(updateDeliveryDetailFail(error.message));
  }
}

export function* archiveDeliveryDetailEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { item } = action.payload;

    const { data } = yield call(
      axiosInstance.delete,
      `${apiURL}/delivery-charges/${action.payload?.item?.id}`,
      action.payload?.item
    );
    if (data?.succeeded) {
      yield put(archiveDeliveryDetailSuccess(data));
      if (item.isActive) {
        toast.success('Delivery charge archived successfully');
      } else {
        toast.success('Delivery charge unarchived successfully');
      }
      yield call(loadDeliveryDetailsEffect, {
        payload: { filters: {}, perPage: 10, page: 1 },
        type: "",
      });
    }
  } catch (error: any) {
    yield put(archiveDeliveryDetailFail(error.message));
  }
}

export function* loadAssignDeliveryDetailEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/rounds/list?SearchValue=${
        action?.payload?.filters?.query ?? ""
      }&PaginationOption.Page=${
        action?.payload?.page
      }&PaginationOption.PageSize=${action.payload?.perPage}`
    );
    yield put(loadAssignDeliveryDetailSuccess(data));
  } catch (error: any) {
    yield put(loadAssignDeliveryDetailFail(error.meessage));
  }
}

export function* deliveryDetailsSaga(): Generator<any, void, any> {
  yield takeEvery(loadDeliveryDetailsRequested, loadDeliveryDetailsEffect);
  yield takeEvery(
    loadDeliveryChargesListRequested,
    loadDeliveryChargesListEffect
  );
  yield takeEvery(
    loadAssignDeliveryDetailRequested,
    loadAssignDeliveryDetailEffect
  );
  yield takeEvery(storeDeliveryDetailRequested, storeDeliveryDetailEffect);
  yield takeEvery(updateDeliveryDetailRequested, updateDeliveryDetailEffect);
  yield takeEvery(archiveDeliveryDetailRequested, archiveDeliveryDetailEffect);
}
